  $(document).ready(function() {
      resize();
  });

  $(window).resize(function() {
      resize();
  });  

  function resize() {	
    if ($(window).outerWidth() > (1023)) {
      /* move quicklinks and preview around */
      $(".quicklinks-container").insertAfter(".developedby-container");
      $(".back-to-top-container-course-outline").insertAfter(".quicklinks-container");
      $(".preview-container").insertAfter(".summary-container");

    } else {
      /* put quick links after preview */
      $(".preview-container").insertAfter(".sidebar-container");
      $(".quicklinks-container").insertAfter(".preview-container");
      $(".back-to-top-container-course-outline").insertAfter(".quicklinks-container");
    }
  }